import React from 'react'

export default function title(title) {
  return (
    <div>
      {document.title=title}
    </div>
  )
}
